<template lang="pug">
.detail.scrollable.h-100
  .mx-4.my-2.px-3.pt-3
    .d-flex.align-items-end
      .d-flex.text-large.mr-4
        | รายการใบเสนอราคาเลขที่
        FormattedEntryNo.ml-2(
          :entryNo='quotation.entryNo'
          :orderId='quotation.id'
        )
      .text-medium.mr-4
        | {{ formattedDate }}
        | เวลา {{ formattedTime }}
      //- CustomStatusBadge(
      //-   :status='quotation.status'
      //-   type='ORDER_STATUS'
      //- )
      //- button.btn.btn-dark.ml-auto
      //-   | ดูเอกสาร PDF

    .d-flex.align-items-center.pt-4.pb-3
      CustomerCompactDetailHeader(:data='customer')
      div.ml-auto.mr-4
        .text-large.mr-3
          | {{ deliveryType }}
        .text-small(v-if='deliveryTypeExtra')
          | {{ deliveryTypeExtra }}

        //- .text-small เลขที่ใบสั่งซื้อจากลูกค้า -

  .sticky-top.bg-white
    .d-flex.px-4.py-2
      .text-large รายการสินค้า
      LoadingIndicator.ml-2(v-if='isLoading')
    hr.m-0

  template(v-if='quotation')
    .px-4.pt-2
      //- div {{ JSON.stringify(quotation) }}
      CustomTable(
        :columns='tableColumns'
        :data='tableData'
      )
    hr.m-0
    .d-flex.justify-content-between.mx-3.px-4.py-4
      //- .d-flex
      //-   div หมายเหตุ
      //-   ol
      //-     li ...
      //-     li ...
      .d-flex.flex-column.align-items-end.ml-auto
        .text-medium
          span.mr-3 รวมมูลค่าทั้งสิ้น
          span.ml-4 {{ total | currency }}
        .text-xlarge.mt-1
          span.mr-3 รวมค่าคอมมิชชั่นที่ได้รับ
          span.ml-4 {{ totalCommission | currency }}

</template>

<script>
import CustomerCompactDetailHeader from '@/components/customers/CustomerCompactDetailHeader.vue';

export default {
  props: {
    customer: {
      default: () => ({}),
    },
    quotation: {
      default: () => ({}),
    },
  },
  computed: {
    formattedDate() {
      return this.$moment(this.quotation.date).format('D MMMM YYYY');
    },
    formattedTime() {
      return this.$moment(this.quotation.time).format('HH:mm');
    },
    deliveryStatus() {
      return this.quotation.shipmentStatus;
    },
    deliveryType() {
      const { ship_type: shipType } = this.quotation;
      return this.$dictionary.deliveryType[shipType];
    },
    deliveryTypeExtra() {
      return this.quotation.ship_to;
    },
  },
  data: () => ({
    tableColumns: {
      productId: {
        title: 'รหัสสินค้า',
        computed(row) {
          return row.product.id;
        },
      },
      productName: {
        title: 'ชื่อสินค้า',
        align: 'left',
        computed(row) {
          return row.product.name;
        },
      },
      amount: {
        title: 'จำนวนสินค้า',
        align: 'right',
      },
      price: {
        title: 'ราคาขาย',
        align: 'right',
        type: Number,
        computed: row => row.price / row.amount,
      },
      total: {
        title: 'ยอดรวม',
        align: 'right',
        type: Number,
        computed: row => row.price,
      },
    },
    tableData: {},
    isLoading: false,

    total: 0,
    totalCommission: 0,
  }),
  watch: {
    quotation() {
      this.quotationUpdated();
      // this.tableData = newVal.products ? newVal.products : [];
    },
  },
  mounted() {
    // this.loadData();
    if (this.quotation) {
      this.quotationUpdated();
    }
  },
  methods: {
    // async loadData() {
    //   this.isLoading = true;

    //   const res = await this.$api.history.quotationItems(this.quotation.entryNo);
    //   if (res.status === 200) {
    //     this.tableData = res.data.data;
    //   }

    //   this.isLoading = false;
    // },
    quotationUpdated() {
      this.tableData = this.quotation.products;

      let total = 0;
      let totalCommission = 0;
      for (let i = 0; i < this.quotation.products.length; i += 1) {
        const PROD = this.quotation.products[i];
        // console.log(PROD);
        total += Number(PROD.price);
        totalCommission += (Number(PROD.commission));
      }

      this.total = total;
      this.totalCommission = totalCommission;
    },
  },
  components: {
    CustomerCompactDetailHeader,
  },
};
</script>

<style lang="scss">
// .detail {}
</style>
